import React from "react";
import cx from "classnames";
import { Pacman } from "@picklebet/ui";

import * as styles from "./ApplePayButton.module.scss";

type ApplePayButtonProps = {
  amount: number;
  isValid: boolean;
  loading?: boolean;
  processing?: boolean;
  className?: string;
  onDeposit: (amount: number) => void;
  onValidationError: () => void;
};

const ApplePayButton = ({
  amount,
  isValid,
  loading = false,
  processing = false,
  className,
  onDeposit,
  onValidationError,
}: ApplePayButtonProps) => {
  return (
    <div
      className={cx(styles.container, className, {
        [styles.busy]: processing,
      })}
    >
      <apple-pay-button
        type="plain"
        buttonstyle="white"
        className={styles.applePay}
        {...(loading || processing ? { disabled: true } : {})}
        onClickCapture={() => {
          // Apple Pay's session must begin within this synchronous user gesture,
          // so validity is checked inline rather than via an async submit handler
          if (!isValid) {
            onValidationError();
            return;
          }
          onDeposit(amount);
        }}
      />

      {processing && (
        <div className={styles.processingOverlay}>
          <Pacman tone="light" size="default" />
        </div>
      )}
    </div>
  );
};

export { ApplePayButton };
